// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dialog_wrapper__2QjjE","card":"dialog_card__2vc1P"};